<template>
  <div class="container">
    <!-- 版主专区 -->
    <div class="search-tab">
      <el-button class="filter-btn" :class="{ 'active': searchForm.search_type == 10 }" type="text"
        @click="handleSearchType(10)">{{ $t('已通过') }}</el-button>
      <el-button class="filter-btn" :class="{ 'active': searchForm.search_type == 20 }" type="text"
        @click="handleSearchType(20)">{{ $t('待审核') }}</el-button>
    </div>
    <!-- 搜索 -->
    <div class="search-box df">
      <div class="search-list list1 df aic">
        <el-input v-model="searchForm.search_key" @keyup.enter.native="handleSearch()" @clear="handleSearch()"
          :placeholder="$t('请输入')" clearable class="f1"></el-input>
        <el-button type="text" class="btn fn" @click="handleSearch()">{{ $t('搜索') }}</el-button>
      </div>
      <div class="search-list f1 list2">
        <el-select v-model="searchForm.area_level1" :placeholder="$t('洲')" clearable @change="handleDistrictChange()">
          <el-option v-for="item in cityList.region_list" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="search-list f1 list3">
        <el-select v-model="searchForm.area_level2" :placeholder="$t('国家/区域')" clearable @change="handleSearch()">
          <el-option v-for="item in cityList.country_list" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="search-list f1 list4">
        <el-select v-model="searchForm.post_scene" :placeholder="$t('场景')" clearable @change="handleSearch()">
          <el-option v-for="item in post_scene_list" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="search-list f1 list5">
        <el-select v-model="searchForm.post_ins" :placeholder="$t('行业')" clearable @change="handleSearch()">
          <el-option v-for="item in post_ins_list" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="search-list list5 ml-16">
        <el-button type="text" @click="handleOpenPost"><span>+</span> {{ $t('发布帖子') }}</el-button>
      </div>
    </div>

    <!-- 列表 -->
    <div class="post-box">
      <div class="list" v-for="(item, index) in dataList" :class="{
        'hot-box': [0, 1, 2].indexOf(index) != -1 && pagination.page == 1,
        'essence-box': item.tp_rec == 1000,
      }" @click="$navigate('/discuss/info', item.tp_id + '/' + is_preview)" :key="index">
        <div class="title df aic jcsb over-h">
          <div class="f1 one-text">
            <span class="essence" v-if="item.tp_rec == 900">{{ $t("精1") }}</span>
            <span class="essence" style="background-color: #FDB906FF;" v-if="item.tp_is_top == 10">{{ $t("顶1") }}</span>
          {{ item.tp_title }}
          </div>
          <div class="show-box fn">
<!--            <img v-if="[0, 1, 2].indexOf(index) != -1 && pagination.page == 1" src="@/assets/images/hot.png" alt="" />-->
<!--            <img v-if="item.tp_is_top == 10" src="@/assets/images/essence.png" alt="" />-->
          </div>

        </div>

        <template v-if="item.tp_status == 30">
          <div class="fs-14 mt-6"
            style="display:inline-block;padding: 5px 12px;border-radius:6px;line-height:24px;background-color: #ffebec; color: #cf2e36">
            <img src="@/assets/images/huifu.png" alt=""> <span class="ml-6">{{ $t('审核回复') }}：{{ item.tp_ai_review_reason
            }}</span>
          </div>
        </template>

        <div class="df aic mt-18">
          <div class="f1 df aic">
            <div @click="(event) => handleaAvatar(event, item)" class="df">
              <template v-if="item.tp_type == 10">
                <el-avatar :size="18" :src="item.user_avatar_att_url" class="fn" @error="handleImageError">
                  <img src="@/assets/images/avatar.png" alt="">
                </el-avatar>
              </template>
              <template v-else>
                <el-avatar :size="18" :src="require('@/assets/images/avatar.png')" class="fn"></el-avatar>
              </template>


            </div>
            <span class="name">{{
              item.is_expert == 10
                ? item.user_name
                : (item.tp_type == 20 || item.user_id == 0 || item.user_nick_name === '' ||
                  item.user_nick_name === null
                  ? $t('匿名用户')
                  : item.user_nick_name)
            }}</span>
            <span class="date">{{ item.tp_published_time }}</span>
            <div class="df pl-18">
              <div class="li">
                <span class="iconfont">&#xe611;</span>
                <span class="text">{{ item.tp_hits }}</span>
              </div>
              <div class="li">
                <span class="iconfont">&#xe61b;</span>
                <span class="text">{{ item.tp_likes }}</span>
              </div>
              <div class="li">
                <span class="iconfont">&#xe63e;</span>
                <span class="text">{{ item.reply_count }}</span>
              </div>
            </div>
          </div>

          <div class="btns">
            <template v-if="item.tp_status === 60">
              <!-- 置顶和置精华 -->
              <el-button v-if="item.tp_is_top === 20 && tpm_topup === 10" type="primary"
                @click="handlerTopup($event, item.tp_id)" class="btn1">{{ $t('置顶') }}</el-button>
              <el-button v-if="item.tp_rec === 10 && tpm_essence === 10" type="primary"
                @click="handleEssence($event, item)" class="btn2" :loading="item.is_loading">{{ $t('置精华') }}</el-button>
              <!-- 取消置顶和取消置精华 -->
              <el-button v-if="item.tp_is_top === 10 && tpm_topup === 10" type="primary"
                @click="cancelTopup(item)" class="btn1" :loading="item.is_loading">{{ $t('取消置顶') }}</el-button>
              <el-button v-if="item.tp_rec === 900 && tpm_essence === 10" type="primary"
                @click="handleEssence($event, item)" class="btn2" :loading="item.is_loading">{{ $t('取消置精华') }}</el-button>

              <!-- 删除按钮 -->
              <el-button v-if="tpm_remove === 10" type="primary" @click="handleDelete($event, item.tp_id)"
                class="btn3">{{ $t('删除') }}</el-button>
            </template>
            <template v-else>
              <!-- 审核按钮 -->
              <el-button v-if="tpm_audit === 10" type="primary" @click="handlerExamine($event, item.tp_id)"
                class="btn4">{{
                  $t('审核') }}</el-button>
            </template>
          </div>

        </div>

      </div>

      <div class="no-data" v-if="dataList.length == 0">
        <img src="@/assets/images/empty_data.png" alt="">
        <p>{{ $t('暂无数据') }}</p>
      </div>

    </div>

    <div class="pageing-box df aic jcc" v-if="dataList.length != 0">

      <el-button type="text" class="add-btn" @click="handlePages(1)">{{ $t('回首页') }}</el-button>
      <el-pagination :current-page="pagination.page" :page-size="20" :total="pagination.total"
        layout=" prev, pager, next,slot" @current-change="handleCurrent">


        <span class="jump-text">{{ $t('跳转') }}</span>
        <el-input-number :controls="false" v-model="jumpIndex" :min="1" :max="totalPages" @change="handleJump"
          size="small" class="jump-ipt" style="width: 28px; margin-left: 8px;" />

      </el-pagination>
      <el-button type="text" class="add-btn ml-11" @click="handlePages(totalPages)">{{ $t('去尾页') }}</el-button>
    </div>
    <!-- 发帖子 -->
    <postModel ref="postDialog" :data="data_list" @post-submitted="handlePostModelSubmitted" />
    <!-- 个人信息 -->
    <avatarTop ref="avatarDialog" @post-submitted="handleAvatarSubmitted" :id="id" :publisherFollowLoading="publisherFollowLoading"  />
    <!-- 审核 -->
    <examine-model ref="examineDialog" :title="$t('帖子审核')" :id="top_id" :examine-loading="examineLoading"
      @poster-submitted="handlerExamineSubmitted"></examine-model>
    <!-- 置顶弹框 -->
    <topup-model ref="topupDialog" :title="$t('置顶')" :id="top_id" @poster-submitted="topupSubmitted" :topLoading="topLoading"></topup-model>

  </div>
</template>


<script>
import postModel from "@comp/postModel.vue";
import { addApipost, getcommonData, getMyInfo, setuserfollowAdd } from "@api/home";
import { audit, moderatorDelete, moderatorList, setEssence, topUp } from "@api/post";
import { getactivityGetArea } from "@api/active";
// 审核
import examineModel from '@/components/examineModel.vue';
import topupModel from "@comp/topupModel.vue";

export default {
  components: { topupModel, postModel, examineModel },
  data() {
    return {
      followLoading: false,
      publisherFollowLoading: false,
      id: 0,
      top_id: 0,
      is_preview: 0,
      examineLoading: false, //审核提交laoding
      topLoading: false, // 置顶提交loading
      defaultAvatar: 'https://www.oceanclub.org/static/protal/images/avatar-default.png',
      // 搜索框
      searchForm: {
        search_type: "",
        search_key: "",
        area_level1: "",
        post_ins: "",
        post_scene: "",
      },
      options: [],
      post_scene_list: [],
      post_ins_list: [],
      cityList: {
        region_list: [],
        country_list: [],
        province_list: [],
        city_list: [],
      },

      pagination: {
        page: 1,
        total: 0,

      },
      totalPages: 0, //总页数
      jumpIndex: '',
      tpm_audit: 20,
      tpm_essence: 20,
      tpm_remove: 20,
      tpm_topup: 20,
      dataList: [],
      data_list: {},
      userinfo: {

      },
    }
  },
  mounted() {
    // 设置默认的顶部菜单背景色
    this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');
    this.getData();
    this.getcitytArea();
    this.getMyInfo();

  },

  methods: {
    // 审核
    handlerExamine(event, tp_id) {
      event.stopPropagation(); // 阻止冒泡
      this.top_id = tp_id;
      this.$refs.examineDialog.openModal();
    },
    handlerTopup(event, tp_id) {
      event.stopPropagation(); // 阻止冒泡
      this.top_id = tp_id;
      this.$refs.topupDialog.openModal();
    },
    posterSubmitted(e) {
      console.log('审核成功', e);
    },

    async getMyInfo() {
      let res = await getMyInfo();
      if (res.status == 200) {
        this.userinfo = res.data;
        if (this.userinfo == null) {
          this.userinfo = [];
        }
      }
    },
    async handleEssence(event, item) {
      if(item.is_loading){return false}
      item.is_loading=true;
      event.stopPropagation(); // 阻止冒泡
      let res = await setEssence({ tp_id: item.tp_id });
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.getData();
      }
      setTimeout(() => {
        item.is_loading=false;
      }, 1000);
    },
    async cancelTopup(item) {
      if(item.is_loading){return false};
      item.is_loading=true;
      event.stopPropagation(); // 阻止冒泡
      let res = await topUp({ id: item.tp_id });
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.getData();
      }
      setTimeout(() => {
        item.is_loading=false;
      }, 1000);
    },
    async handleDelete(event, tp_id) {
      event.stopPropagation(); // 阻止冒泡
      this.$confirm(this.$t("此操作将删除该条记录, 是否继续?"), {
        confirmButtonText: this.$t("确定"),
        cancelButtonText: this.$t("取消"),
        type: 'warning',
      })
        .then(async () => {
          // 执行删除操作
          let res = await moderatorDelete({ tp_id: tp_id });
          if (res.status == 200) {
            this.$message.success(res.msg);
            this.getData();
          }
        })
        .catch(() => { });


      // let res = await moderatorDelete({ tp_id: tp_id });
      // if (res.status == 200) {
      //   this.$message.success(res.msg);
      //   this.getData();
      // }
    },
    handleSearch() {
      this.getData();
    },
    handleDistrictChange() {
      // 更改洲后清空后续选项
      this.searchForm.area_level2 = null;
      // 获取新的国家列表
      this.getcitytArea({
        act_region: this.searchForm.area_level1,
        act_country: 0,
      });
      this.getData();
    },
    // 区域筛选
    async getcitytArea(obj = {}) {
      let res = await getactivityGetArea({ ...obj });

      if (res.status == 200) {
        this.cityList = res.data;
      }

    },
    async handleAvatarSubmitted(id) {
      this.publisherFollowLoading = true;
      let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
      if (res.status == 200) {
        this.$message.success(res.msg);
      }
      setTimeout(() => {
        this.publisherFollowLoading = false;
      }, 1000);
    },
    handleaAvatar(event, item) {
      // 判断是否是实名用户
      if (item.tp_type == 20 || item.user_id == 0 || item.user_nick_name == '' || item.user_nick_name == null) {
        return false;
      }
      event.stopPropagation(); // 阻止事件冒泡
      this.$refs.avatarDialog.openModal();
      this.id = item.user_id;

    },
    // 头像加载失败
    handleImageError() {
      return true;

    },
    handleSearchType(value) {
      this.searchForm.search_type = value;
      if (value == 10) {
        this.is_preview = 0;
      } else {
        this.is_preview = 1;
      }
      this.getData();
    },
    handlePages(index) {
      this.pagination.page = index;
      this.getData();
    },
    // 分页改变
    handleCurrent(val) {
      this.pagination.page = val;
      this.getData();
    },
    // 跳转
    handleJump() {
      this.pagination.page = this.jumpIndex;
      this.getData();
    },
    async handleOpenPost() {
      if (this.userinfo.length == 0) {
        setTimeout(() => {
          let str = "/protal";
          let Language = localStorage.getItem('currentLanguage');  //获取本地语言
          if (Language && Language != 'zh') {
            str = "/protal_" + Language;
          }
          const parsedUrl = new URL(window.location.href);
          const path = parsedUrl.pathname; // This will give you the path

          const url = str + '/login?callback=' + path; // 你想要跳转的 URL
          window.open(url);

        }, 1000);
        return false;
      }
      let res = await getcommonData();
      if (res.status == 200) {
        this.data_list = res.data;
      }
      this.$refs.postDialog.openModal();
    },
    async handlePostModelSubmitted(content) {

      let res = await addApipost(content);
      if (res.status == 200) {
        this.$message.success(res.msg);
      }
    },
    async topupSubmitted(content) {
      this.topLoading = true;
      let res = await topUp(content);
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.$refs.topupDialog.closeModal();
        this.getData();
      }
      setTimeout(() => {
        this.topLoading=false;
      }, 1000);
    },
    async handlerExamineSubmitted(content) {
      this.examineLoading = true;
      let res = await audit(content);
      this.examineLoading = false;
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.$refs.examineDialog.closeModal();
        this.getData();
        // this.examineLoading = false;
      }

    },
    async getData() {
      let res = await moderatorList({ ...this.searchForm, page: this.pagination.page });
      if (res.status == 200) {
        this.pagination.total = res.data.post_list.total;
        this.totalPages = Math.ceil(this.pagination.total / 20);
        this.dataList = res.data.post_list.data;
        this.post_scene_list = res.data.moderator_scene_list;
        this.post_ins_list = res.data.moderator_ins_list;
        if (res.data.moderator_data) {
          this.tpm_audit = res.data.moderator_data.tpm_audit;
          this.tpm_essence = res.data.moderator_data.tpm_essence;
          this.tpm_remove = res.data.moderator_data.tpm_remove;
          this.tpm_topup = res.data.moderator_data.tpm_topup;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pageing-box {
  ::v-deep() {
    .el-pagination button:disabled {
      background-color: transparent;
    }

    .el-pager li {
      background: transparent;
    }

    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      background-color: transparent;
    }

    .jump-ipt {
      box-sizing: border-box;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 8px;
      background: rgb(255, 255, 255);
      width: 28px;
      height: 28px;
    }

    .jump-ipt .el-input__inner {
      padding: 0;
      height: 26px;
      line-height: 26px;
      border: none;
      position: relative;
      top: -2px;
      background-color: transparent;
    }
  }
}

.container {
  padding-top: 90px;
  padding-left: 80px;
  padding-right: 80px;
  padding-bottom: 60px;
  background: #F8F8F8;
  min-height: calc(100vh - 280px);

  .search-tab {
    max-width: 1400px;
    margin: 0 auto;
    padding-top: 40px;
    padding-bottom: 19px;

    .filter-btn {
      font-size: 16px;
      color: #999999;
      line-height: 20px;
      margin-right: 36px;
      position: relative;
      transition: all 0.36s;

      &:hover,
      &.active {
        color: #B7251E;
      }
    }
  }

  .search-box {
    max-width: 1400px;
    margin: 0 auto;

    .search-list {
      height: 54px;
      border-radius: 100px;
      border: 1px solid rgba($color: #b7251e, $alpha: 0.4);
      margin-right: 16px;
      transition: border 0.36s;
      overflow: hidden;

      &:hover {
        border: 1px solid rgba($color: #b7251e, $alpha: 1);
      }
    }

    .list5 {
      width: 114px;
      margin-right: 0;
    }

    .list2,
    .list3,
    .list4 {}

    .list1 {
      width: 480px;
      padding-right: 30px;

      .btn {
        width: auto;
      }
    }

    ::v-deep() {
      .el-input__inner {
        height: 52px;
        border: none;
        background: transparent;
        padding-left: 20px;
        padding-right: 30px;
        color: #757575;

        &::placeholder {
          color: #757575;
        }
      }

      .el-input__suffix {
        right: 14px;
      }

      .el-select {
        width: 100%;
      }

      .el-select>.el-input {
        width: 100%;
      }

      .el-button--text {
        width: 100%;
        height: 52px;
      }
    }

  }

  .post-box {
    max-width: 1400px;
    margin: 30px auto;
    padding: 16px 26px;
    background: #ffffff;

    .list {
      padding-bottom: 28px;
      padding-top: 18px;
      position: relative;
      cursor: pointer;
      border-bottom: 1px solid rgba($color: #9F8686, $alpha: 0.2);

      &:last-child {
        border-bottom: none;
      }

      &::after {
        content: "";
        height: 1px;
        width: 0%;
        background: #B7251E;
        position: absolute;
        bottom: 0;
        left: 0;
        transition: all 0.2s;
      }

      &:hover {
        .title {
          color: #B7251E;
        }

        &::after {
          width: 100%;
        }
      }

      .title {
        font-family: "MicrosoftYaHeiSemibold";
        color: rgb(25, 25, 25);
        font-size: 20px;
        font-weight: 400;
        line-height: 24px;
        padding: 2px 0;

        .essence,
        .hot {
          display: inline-block;
          min-width: 18px;
          height: 18px;
          border-radius: 2px;
          font-size: 14px;
          color: #ffffff;
          line-height: 18px;
          text-align: center;
          margin-right: 4px;
          position: relative;
          padding: 0 2px;
          top: -2px;
        }

        .essence {
          background: rgb(215, 17, 17);
        }

        .hot {
          background: rgb(255, 110, 0);
        }

        .show-box {
          img {
            margin-left: 6px;
          }
        }

      }

      .name {
        font-size: 16px;
        margin-left: 12px;
        line-height: 24px;
        position: relative;
        padding-right: 16px;

        &::after {
          content: '';
          display: inline-block;
          width: 1px;
          height: 14px;
          background: rgba($color: #9F8686, $alpha: 0.2);
          margin-left: 16px;
          position: absolute;
          top: 5px;
          right: 0;
        }
      }

      .date {
        font-size: 14px;
        color: #9F8686;
        line-height: 24px;
        margin-left: 12px;
      }

      .li {
        font-size: 14px;
        color: #9F8686;
        line-height: 24px;
        margin-left: 16px;

        .iconfont {
          margin-right: 4px;
        }
      }

      .btns {
        button {
          height: 32px;
          line-height: 32px;
          padding: 0 18px;
          border-radius: 20px;
          margin: 0;
          margin-left: 16px;
          font-size: 12px;
          transition: all 0.2s;
        }

        .btn1 {

          border-color: #FFF0F1;
          background: #FFF0F1;
          color: #B7251E;

          &:hover {
            border-color: #B7251E;
            background: #B7251E;
            color: #ffffff;
          }
        }

        .btn2 {
          border-color: #E2FFFD;
          background: #E2FFFD;
          color: #06EBB6;

          &:hover {
            border-color: #06EBB6;
            background: #06EBB6;
            color: #ffffff;
          }
        }

        .btn3 {
          border-color: #F6F6F6;
          background: #F6F6F6;
          color: #160404;
        }
      }
    }
  }

}

@media screen and (max-width: 1400px) {
  .container .search-box .list1 {
    width: 360px;
  }
}

@media screen and (max-width: 1280px) {
  .container .search-box .list1 {
    width: 240px;
  }
}
</style>